import React, { PropsWithChildren } from 'react';
// import styles from './SGSTabPanel.module.scss';

type Props = {
    /** Value of the selected tab */
    value: number;
    /** Index of the current tab */
    index: number;
    className?: string;
};

const SGSTabPanel: React.FC<PropsWithChildren<Props>> = ({ children, value, index, className }) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            className={className}
            // id={`tabpanel-${index}`}
            // aria-labelledby={`tab-${index}`}
        >
            {value === index && children}
        </div>
    );
};

export default SGSTabPanel;
